












import { mapState } from "vuex";
import { Vue, Component, Prop } from "vue-property-decorator";
import IConditionsListPanel from "@/general/components/pages/parts/GrantCriteriaList/IConditionsListPanel.vue";

@Component({
  components: {
    IConditionsListPanel
  }
})
export default class IConditionsList extends Vue {
  @Prop({ type: Array, default: [], required: true }) conditionsList!: [];
}
